module.exports = __webpack_public_path__ + "static/media/Οδοιπορικό Ελληνική Κοινότητα Κωφών..1e42b3f4.mp4";